<nz-page-header nzTitle="Create Form" nzSubtitle="Configure the basic form information">
</nz-page-header>


<form nz-form [formGroup]="form">


        <!-- ===================================================== -->
        <!-- BASIC FORM INFORMATION -->
        <!-- ===================================================== -->

        <nz-form-item>

                <nz-form-label [nzSpan]="6" nzRequired>

                        Name

                </nz-form-label>

                <nz-form-control [nzSpan]="18" nzErrorTip="Please enter a form name">

                        <input nz-input formControlName="name" placeholder="Enter form name" />

                </nz-form-control>

        </nz-form-item>


        <nz-form-item>

                <nz-form-label [nzSpan]="6">

                        Description

                </nz-form-label>

                <nz-form-control [nzSpan]="18">

                        <textarea nz-input formControlName="description" rows="4" placeholder="Enter form description">
			</textarea>

                </nz-form-control>

        </nz-form-item>

        <nz-card nzTitle="Workflow" class="mb-3">

                <p class="text-muted">
                        Select where this form will operate within PANDA.
                </p>


                <div class="row g-3">

                        <!-- WORKFLOW -->

                        <div class="col-md-4">

                                <label class="form-label">
                                        Workflow
                                        <span class="required-indicator">
                                                *
                                        </span>
                                </label>

                                <nz-select formControlName="workflowId" nzPlaceHolder="Select workflow" nzShowSearch
                                        style="width: 100%;" (ngModelChange)="
        					onWorkflowChanged($event)
        				">

                                        <nz-option *ngFor="
        						let workflow of workflows
        					" [nzValue]="workflow.id" [nzLabel]="
        						workflow.label ||
        						workflow.name
        					">
                                        </nz-option>

                                </nz-select>

                        </div>


                        <!-- STEP -->

                        <div class="col-md-4">

                                <label class="form-label">
                                        Workflow Step
                                        <span class="required-indicator">
                                                *
                                        </span>
                                </label>

                                <nz-select formControlName="workflowStepId" nzPlaceHolder="Select workflow step"
                                        nzShowSearch style="width: 100%;" [nzDisabled]="
        					!form.get('workflowId')?.value
        				" (ngModelChange)="
        					onWorkflowStepChanged($event)
        				">

                                        <nz-option *ngFor="
        						let step of workflowSteps
        					" [nzValue]="step.id" [nzLabel]="step.label">
                                        </nz-option>

                                </nz-select>

                        </div>


                        <!-- STATUS -->

                        <div class="col-md-4">

                                <label class="form-label">
                                        Status
                                </label>

                                <nz-select formControlName="workflowStatusId" nzPlaceHolder="All statuses" nzAllowClear
                                        nzShowSearch style="width: 100%;" [nzDisabled]="
        					!form.get(
        						'workflowStepId'
        					)?.value
        				">

                                        <nz-option *ngFor="
        						let status of
        						workflowStatuses
        					" [nzValue]="status.id" [nzLabel]="status.label">
                                        </nz-option>

                                </nz-select>

                                <small class="text-muted">
                                        Leave blank if the form applies
                                        to the whole step.
                                </small>

                        </div>

                </div>

        </nz-card>

        <nz-card nzTitle="Logo" class="mb-3">

                <p class="text-muted">
                        Optional logo displayed at the top of this form.
                </p>

                <div class="row g-3 align-items-center">

                        <div class="col-md-6">

                                <label class="form-label">
                                        Form Logo
                                </label>

                                <input #logoInput type="file" class="form-control"
                                        accept="image/png,image/jpeg,image/webp,image/svg+xml"
                                        (change)="onLogoSelected($event)" />

                        </div>

                        <div class="col-md-6" *ngIf="form.get('formLogo.dataUrl')?.value">

                                <div class="logo-builder-preview">

                                        <img [src]="form.get('formLogo.dataUrl')?.value" alt="Form logo" />

                                        <div class="mt-2">

                                                <small class="text-muted me-3">
                                                        {{ form.get('formLogo.fileName')?.value }}
                                                </small>

                                                <button type="button" nz-button nzSize="small" nzDanger
                                                        (click)="clearLogo(logoInput)">
                                                        Remove Logo
                                                </button>

                                        </div>

                                </div>

                        </div>

                </div>

        </nz-card>


        <div class="text-end mt-3">

                <button nz-button type="button" class="me-2" (click)="doCancel()">

                        Cancel

                </button>

                <button nz-button nzType="primary" type="button" [disabled]="form.invalid" (click)="doSave()">

                        Save

                </button>

        </div>


        <hr class="mt-4 mb-4">


        <!-- ===================================================== -->
        <!-- FORM LAYOUT -->
        <!-- ===================================================== -->

        <div class="
			d-flex
			justify-content-between
			align-items-center
			mb-3
		">

                <div>

                        <h4 class="mb-0">
                                Form Layout
                        </h4>

                        <small class="text-muted">
                                Add sections to organise the fields on this form.
                        </small>

                </div>


                <button nz-button nzType="dashed" type="button" (click)="addSection()">

                        + Add Section

                </button>

        </div>


        <!-- ===================================================== -->
        <!-- SECTIONS -->
        <!-- ===================================================== -->

        <div formArrayName="sections" cdkDropList (cdkDropListDropped)="dropSection($event)">


                <nz-card *ngFor="
				let section of sections.controls;
				let i = index
			" cdkDrag class="mb-3 section-card">


                        <div [formGroupName]="i">


                                <!-- SECTION HEADER -->

                                <div class="
						d-flex
						justify-content-between
						align-items-center
						mb-3
					">

                                        <div class="
							d-flex
							align-items-center
						">

                                                <button nz-button nzSize="small" type="button" cdkDragHandle
                                                        title="Drag section" class="me-2">

                                                        ☰

                                                </button>

                                                <strong>
                                                        Section {{ i + 1 }}
                                                </strong>

                                        </div>


                                        <button nz-button nzDanger nzSize="small" type="button"
                                                (click)="removeSection(i)">

                                                Remove

                                        </button>

                                </div>


                                <!-- SECTION NAME -->

                                <nz-form-item>

                                        <nz-form-label [nzSpan]="6" nzRequired>

                                                Section Name

                                        </nz-form-label>

                                        <nz-form-control [nzSpan]="18">

                                                <input nz-input formControlName="name"
                                                        placeholder="Enter section name" />

                                        </nz-form-control>

                                </nz-form-item>


                                <!-- SECTION DESCRIPTION -->

                                <nz-form-item>

                                        <nz-form-label [nzSpan]="6">

                                                Description

                                        </nz-form-label>

                                        <nz-form-control [nzSpan]="18">

                                                <input nz-input formControlName="description"
                                                        placeholder="Optional section description" />

                                        </nz-form-control>

                                </nz-form-item>


                                <!-- ================================================= -->
                                <!-- FIELDS -->
                                <!-- ================================================= -->

                                <div class="mt-4">


                                        <div class="
							d-flex
							justify-content-between
							align-items-center
							mb-2
						">

                                                <strong>
                                                        Fields
                                                </strong>


                                                <button nz-button nzType="dashed" nzSize="small" type="button"
                                                        (click)="addField(i)">

                                                        + Add Field

                                                </button>

                                        </div>


                                        <div formArrayName="fields" cdkDropList
                                                (cdkDropListDropped)="dropField(i, $event)">


                                                <!-- FIELD -->

                                                <div *ngFor="
								let field of getFields(i).controls;
								let j = index
							" [formGroupName]="j" cdkDrag class="field-row mb-3">


                                                        <!-- ========================================= -->
                                                        <!-- MAIN FIELD SETTINGS -->
                                                        <!-- ========================================= -->

                                                        <div class="
									row
									g-2
									align-items-center
								">


                                                                <!-- LABEL -->

                                                                <div class="col-md-3">

                                                                        <input nz-input formControlName="label"
                                                                                placeholder="Field label" />

                                                                </div>


                                                                <!-- TYPE -->

                                                                <div class="col-md-2">

                                                                        <nz-select formControlName="type"
                                                                                style="width: 100%;">

                                                                                <nz-option nzLabel="Text"
                                                                                        nzValue="Text">
                                                                                </nz-option>

                                                                                <nz-option nzLabel="Textarea"
                                                                                        nzValue="Textarea">
                                                                                </nz-option>

                                                                                <nz-option nzLabel="Number"
                                                                                        nzValue="Number">
                                                                                </nz-option>

                                                                                <nz-option nzLabel="Date"
                                                                                        nzValue="Date">
                                                                                </nz-option>

                                                                                <nz-option nzLabel="Dropdown"
                                                                                        nzValue="Dropdown">
                                                                                </nz-option>

                                                                                <nz-option nzLabel="Checkbox"
                                                                                        nzValue="Checkbox">
                                                                                </nz-option>

                                                                                <nz-option nzLabel="Signature"
                                                                                        nzValue="Signature">
                                                                                </nz-option>

                                                                        </nz-select>

                                                                </div>


                                                                <!-- DIRECTION -->

                                                                <div class="col-md-2">

                                                                        <nz-select formControlName="direction"
                                                                                style="width: 100%;"
                                                                                [nzDisabled]="field.get('type')?.value === 'Signature'">

                                                                                <nz-option nzLabel="Input"
                                                                                        nzValue="Input">
                                                                                </nz-option>

                                                                                <nz-option nzLabel="Output"
                                                                                        nzValue="Output">
                                                                                </nz-option>

                                                                                <nz-option nzLabel="Input + Output"
                                                                                        nzValue="InputOutput">
                                                                                </nz-option>

                                                                        </nz-select>

                                                                </div>


                                                                <!-- WIDTH -->

                                                                <div class="col-md-2">

                                                                        <nz-select formControlName="width"
                                                                                style="width: 100%;">

                                                                                <nz-option nzLabel="Full"
                                                                                        [nzValue]="24">
                                                                                </nz-option>

                                                                                <nz-option nzLabel="Half"
                                                                                        [nzValue]="12">
                                                                                </nz-option>

                                                                                <nz-option nzLabel="1/3" [nzValue]="8">
                                                                                </nz-option>

                                                                                <nz-option nzLabel="1/4" [nzValue]="6">
                                                                                </nz-option>

                                                                        </nz-select>

                                                                </div>


                                                                <!-- REQUIRED -->

                                                                <div class="col-md-1">

                                                                        <label nz-checkbox formControlName="required">

                                                                                Required

                                                                        </label>

                                                                </div>


                                                                <!-- READ ONLY -->

                                                                <div class="col-md-1">

                                                                        <label nz-checkbox formControlName="readOnly">

                                                                                Read Only

                                                                        </label>

                                                                </div>


                                                                <!-- ACTIONS -->

                                                                <div class="
										col-md-1
										text-end
									">

                                                                        <button nz-button nzSize="small" type="button"
                                                                                cdkDragHandle title="Drag to reorder">

                                                                                ☰

                                                                        </button>

                                                                        <button nz-button nzDanger nzSize="small"
                                                                                type="button" class="mt-1"
                                                                                (click)="removeField(i, j)">

                                                                                ×

                                                                        </button>

                                                                </div>

                                                        </div>


                                                        <!-- ========================================= -->
                                                        <!-- DISPLAY SETTINGS -->
                                                        <!-- ========================================= -->

                                                        <div class="row g-2 mt-2">

                                                                <div class="col-md-6">

                                                                        <label class="form-label">
                                                                                Placeholder
                                                                        </label>

                                                                        <input nz-input formControlName="placeholder"
                                                                                placeholder="Placeholder text" />

                                                                </div>


                                                                <div class="col-md-6">

                                                                        <label class="form-label">
                                                                                Help Text
                                                                        </label>

                                                                        <input nz-input formControlName="helpText"
                                                                                placeholder="Help text / instructions" />

                                                                </div>

                                                        </div>


                                                        <!-- ========================================= -->
                                                        <!-- DATA BINDING -->
                                                        <!-- ========================================= -->

                                                        <div class="row g-3 mt-2"
                                                                *ngIf="field.get('type')?.value !== 'Signature'">


                                                                <!-- SOURCE -->

                                                                <div class="col-md-6" *ngIf="
										field.get('direction')?.value === 'Output' ||
										field.get('direction')?.value === 'InputOutput'
									">

                                                                        <div class="binding-box">

                                                                                <strong>
                                                                                        Source
                                                                                </strong>

                                                                                <small class="
												text-muted
												d-block
												mb-2
											">
                                                                                        Data that PANDA will load into
                                                                                        this field.
                                                                                </small>


                                                                                <label class="form-label">
                                                                                        Source Entity
                                                                                        <span
                                                                                                class="required-indicator">*</span>
                                                                                </label>

                                                                                <nz-select
                                                                                        formControlName="sourceEntityId"
                                                                                        nzPlaceHolder="Select source entity"
                                                                                        nzShowSearch
                                                                                        style="width: 100%;">

                                                                                        <nz-option
                                                                                                [nzValue]="WORKFLOW_ENTITY_ID"
                                                                                                nzLabel="Workflow">
                                                                                        </nz-option>

                                                                                        <nz-option *ngFor="
													let entity of dynamicEntities
												" [nzValue]="entity.id" [nzLabel]="getEntityLabel(entity)">
                                                                                        </nz-option>

                                                                                </nz-select>


                                                                                <label class="form-label mt-2">
                                                                                        Source Property
                                                                                        <span
                                                                                                class="required-indicator">*</span>
                                                                                </label>

                                                                                <nz-select
                                                                                        formControlName="sourcePropertyId"
                                                                                        nzPlaceHolder="Select source property"
                                                                                        nzShowSearch
                                                                                        style="width: 100%;"
                                                                                        [nzDisabled]="
												!field.get('sourceEntityId')?.value
											">

                                                                                        <nz-option *ngFor="
													let property of
													entityProperties[
														field.get('sourceEntityId')?.value
													] || []
												" [nzValue]="property.id" [nzLabel]="getPropertyLabel(property)">
                                                                                        </nz-option>

                                                                                </nz-select>

                                                                        </div>

                                                                </div>


                                                                <!-- TARGET -->

                                                                <div class="col-md-6" *ngIf="
										field.get('direction')?.value === 'Input' ||
										field.get('direction')?.value === 'InputOutput'
									">

                                                                        <div class="binding-box">

                                                                                <strong>
                                                                                        Target
                                                                                </strong>

                                                                                <small class="
												text-muted
												d-block
												mb-2
											">
                                                                                        Where PANDA will save the value
                                                                                        entered in this field.
                                                                                </small>


                                                                                <label class="form-label">
                                                                                        Target Entity
                                                                                </label>

                                                                                <nz-select
                                                                                        formControlName="targetEntityId"
                                                                                        nzPlaceHolder="Select target entity"
                                                                                        nzShowSearch
                                                                                        style="width: 100%;">

                                                                                        <nz-option
                                                                                                [nzValue]="WORKFLOW_ENTITY_ID"
                                                                                                nzLabel="Workflow">
                                                                                        </nz-option>

                                                                                        <nz-option
                                                                                                *ngFor="let entity of dynamicEntities"
                                                                                                [nzValue]="entity.id"
                                                                                                [nzLabel]="getEntityLabel(entity)">
                                                                                        </nz-option>

                                                                                </nz-select>


                                                                                <label class="
												form-label
												mt-2
											">
                                                                                        Target Property
                                                                                </label>

                                                                                <nz-select
                                                                                        formControlName="targetPropertyId"
                                                                                        nzPlaceHolder="Select target property"
                                                                                        nzShowSearch
                                                                                        style="width: 100%;"
                                                                                        [nzDisabled]="
												!field.get('targetEntityId')?.value
											">

                                                                                        <nz-option *ngFor="
													let property of
													entityProperties[
														field.get('targetEntityId')?.value
													] || []
												" [nzValue]="property.id" [nzLabel]="getPropertyLabel(property)">
                                                                                        </nz-option>

                                                                                </nz-select>

                                                                        </div>

                                                                </div>

                                                        </div>

                                                </div>


                                                <!-- NO FIELDS -->

                                                <div *ngIf="
								getFields(i).length === 0
							" class="
								text-center
								text-muted
								p-4
							" style="
								border: 1px dashed #d9d9d9;
							">

                                                        No fields added yet

                                                </div>

                                        </div>

                                </div>


                                <!-- ================================================= -->
                                <!-- PREVIEW -->
                                <!-- ================================================= -->

                                <hr class="mt-4 mb-3">


                                <div class="
						d-flex
						justify-content-between
						align-items-center
					">

                                        <strong>
                                                Preview
                                        </strong>

                                        <small class="text-muted">
                                                Form layout preview
                                        </small>

                                </div>


                                <div class="row g-3 mt-1">


                                        <div *ngFor="
							let field of getFields(i).controls
						" [ngClass]="
							getPreviewColumnClass(
								field.get('width')?.value
							)
						">


                                                <div class="preview-field">


                                                        <label class="preview-label">

                                                                {{ field.get('label')?.value }}

                                                                <span *ngIf="
										field.get('required')?.value
									" class="required-indicator">

                                                                        *

                                                                </span>

                                                        </label>


                                                        <ng-container [ngSwitch]="
									field.get('type')?.value
								">


                                                                <!-- TEXT -->

                                                                <input *ngSwitchCase="'Text'" nz-input [placeholder]="
                                                                		field.get('placeholder')?.value ||
                                                                		field.get('label')?.value
                                                                	" [required]="field.get('required')?.value"
                                                                        [attr.pattern]="
                                                                		field.get('regex')?.value || null
                                                                	" [disabled]="
                                                                		field.get('readOnly')?.value ||
                                                                		field.get('direction')?.value === 'Output'
                                                                	" />


                                                                <!-- TEXTAREA -->

                                                                <textarea *ngSwitchCase="'Textarea'" nz-input rows="3"
                                                                        [placeholder]="
                                                                		field.get('placeholder')?.value ||
                                                                		field.get('label')?.value
                                                                	" [required]="field.get('required')?.value"
                                                                        [attr.pattern]="
                                                                		field.get('regex')?.value || null
                                                                	" [disabled]="
                                                                		field.get('readOnly')?.value ||
                                                                		field.get('direction')?.value === 'Output'
                                                                	">
                                                                </textarea>


                                                                <!-- NUMBER -->

                                                                <input *ngSwitchCase="'Number'" nz-input type="number"
                                                                        [placeholder]="
                                                                		field.get('placeholder')?.value ||
                                                                		field.get('label')?.value
                                                                	" [required]="field.get('required')?.value"
                                                                        [attr.min]="
                                                                		field.get('minValue')?.value ?? null
                                                                	" [attr.max]="
                                                                		field.get('maxValue')?.value ?? null
                                                                	" [disabled]="
                                                                		field.get('readOnly')?.value ||
                                                                		field.get('direction')?.value === 'Output'
                                                                	" />


                                                                <!-- DATE -->

                                                                <input *ngSwitchCase="'Date'" nz-input type="date"
                                                                        [required]="field.get('required')?.value"
                                                                        [disabled]="
                                                                		field.get('readOnly')?.value ||
                                                                		field.get('direction')?.value === 'Output'
                                                                	" />


                                                                <!-- DROPDOWN -->

                                                                <nz-select *ngSwitchCase="'Dropdown'"
                                                                        style="width: 100%;"
                                                                        nzPlaceHolder="Select option" [nzDisabled]="
                                                                		field.get('readOnly')?.value ||
                                                                		field.get('direction')?.value === 'Output'
                                                                	">

                                                                        <nz-option *ngFor="
                                                                			let option of
                                                                			field.get('options')?.value || []
                                                                		" [nzLabel]="option.label" [nzValue]="
                                                                			option.value !== undefined
                                                                				? option.value
                                                                				: option.label
                                                                		">
                                                                        </nz-option>

                                                                </nz-select>


                                                                <!-- CHECKBOX -->

                                                                <label *ngSwitchCase="'Checkbox'" nz-checkbox
                                                                        [nzDisabled]="
										field.get('readOnly')?.value ||
										field.get('direction')?.value === 'Output'
									">

                                                                        {{ field.get('label')?.value }}

                                                                </label>
                                                                <input *ngSwitchCase="'File'" type="file"
                                                                        class="form-control"
                                                                        [disabled]="field.get('readOnly')?.value" />

                                                                <div *ngSwitchCase="'Signature'"
                                                                        class="signature-wrapper">

                                                                        <canvas #signatureCanvas
                                                                                class="signature-canvas" width="800"
                                                                                height="180"
                                                                                [class.signature-disabled]="
                                                                                                                                                                                			field.get('readOnly')?.value ||
                                                                                                                                                                                			field.get('direction')?.value === 'Output'
                                                                                                                                                                                		"
                                                                                (mousedown)="
                                                                                                                                                                                			startSignature(
                                                                                                                                                                                				$event,
                                                                                                                                                                                				field
                                                                                                                                                                                			)
                                                                                                                                                                                		"
                                                                                (mousemove)="
                                                                                                                                                                                			drawSignature(
                                                                                                                                                                                				$event,
                                                                                                                                                                                				field
                                                                                                                                                                                			)
                                                                                                                                                                                		"
                                                                                (mouseup)="
                                                                                                                                                                                			stopSignature(field)
                                                                                                                                                                                		"
                                                                                (mouseleave)="
                                                                                                                                                                                			stopSignature(field)
                                                                                                                                                                                		"
                                                                                (touchstart)="
                                                                                                                                                                                			startSignature(
                                                                                                                                                                                				$event,
                                                                                                                                                                                				field
                                                                                                                                                                                			)
                                                                                                                                                                                		"
                                                                                (touchmove)="
                                                                                                                                                                                			drawSignature(
                                                                                                                                                                                				$event,
                                                                                                                                                                                				field
                                                                                                                                                                                			)
                                                                                                                                                                                		"
                                                                                (touchend)="
                                                                                                                                                                                			stopSignature(field)
                                                                                                                                                                                		">
                                                                        </canvas>

                                                                        <div
                                                                                class="
                                                                                                                                                                                			d-flex
                                                                                                                                                                                			justify-content-between
                                                                                                                                                                                			align-items-center
                                                                                                                                                                                			mt-2
                                                                                                                                                                                		">

                                                                                <small class="text-muted">
                                                                                        Sign inside the box above
                                                                                </small>

                                                                                <button type="button" nz-button
                                                                                        nzSize="small"
                                                                                        (click)="
                                                                                                                                                                                				clearSignature(
                                                                                                                                                                                					signatureCanvas,
                                                                                                                                                                                					field
                                                                                                                                                                                				)
                                                                                                                                                                                			"
                                                                                        [disabled]="
                                                                                                                                                                                				field.get('readOnly')?.value ||
                                                                                                                                                                                				field.get('direction')?.value === 'Output'
                                                                                                                                                                                			">
                                                                                        Clear Signature
                                                                                </button>

                                                                        </div>

                                                                </div>


                                                                <!-- DEFAULT -->

                                                                <input *ngSwitchDefault nz-input disabled />

                                                        </ng-container>


                                                        <!-- HELP TEXT -->

                                                        <small *ngIf="
									field.get('helpText')?.value
								" class="
									text-muted
									d-block
									mt-1
								">

                                                                {{ field.get('helpText')?.value }}

                                                        </small>

                                                        <div *ngIf="
                                                        		field.get('required')?.value ||
                                                        		field.get('minValue')?.value !== null ||
                                                        		field.get('maxValue')?.value !== null ||
                                                        		field.get('regex')?.value
                                                        	" class="validation-preview mt-2">

                                                                <small class="text-muted">

                                                                        <span *ngIf="field.get('required')?.value">
                                                                                Required
                                                                        </span>

                                                                        <span *ngIf="
                                                        				field.get('minValue')?.value !== null
                                                        			">
                                                                                <span
                                                                                        *ngIf="field.get('required')?.value">
                                                                                        •
                                                                                </span>

                                                                                Min:
                                                                                {{ field.get('minValue')?.value }}
                                                                        </span>

                                                                        <span *ngIf="
                                                        				field.get('maxValue')?.value !== null
                                                        			">
                                                                                •
                                                                                Max:
                                                                                {{ field.get('maxValue')?.value }}
                                                                        </span>

                                                                </small>

                                                        </div>


                                                        <!-- SOURCE BINDING DEBUG/PREVIEW -->

                                                        <small *ngIf="
									field.get('sourceEntityId')?.value &&
									field.get('sourcePropertyId')?.value
								" class="
									binding-preview
									d-block
									mt-2
								">

                                                                Source:
                                                                {{
                                                                getEntityLabelById(
                                                                field.get('sourceEntityId')?.value
                                                                )
                                                                }}
                                                                →
                                                                {{
                                                                getPropertyLabelById(
                                                                field.get('sourceEntityId')?.value,
                                                                field.get('sourcePropertyId')?.value
                                                                )
                                                                }}

                                                        </small>




                                                        <small *ngIf="
									field.get('targetEntityId')?.value &&
									field.get('targetPropertyId')?.value
								" class="
									binding-preview
									d-block
								">

                                                                Target:
                                                                {{
                                                                getEntityLabelById(
                                                                field.get('targetEntityId')?.value
                                                                )
                                                                }}
                                                                →
                                                                {{
                                                                getPropertyLabelById(
                                                                field.get('targetEntityId')?.value,
                                                                field.get('targetPropertyId')?.value
                                                                )
                                                                }}

                                                        </small>


                                                </div>

                                        </div>

                                </div>

                        </div>

                </nz-card>

        </div>

</form>